import Urls from 'mangools-commons/dist/constants/Urls';
import { OnboardingButton } from 'components/layout/navbar/microAppLoaders/OnboardingButton';

export const HELP_DROPDOWN_ITEMS = [
    {
        label: 'Interactive walkthroughs',
        items: [
            {
                element: <OnboardingButton />,
            },
        ],
    },
    {
        label: 'Guides on our blog',
        items: [
            {
                label: 'How to: KWFinder guide',
                link: `${Urls.KWFINDER_GUIDE_URL}?ref=header-app-kw`,
                description: '28 min read',
            },
            {
                label: 'Keyword research for SEO',
                link: `${Urls.MANGOOLS_KEYWORD_RESEARCH_GUIDE_URL}?ref=header-app-kw`,
                description: '58 min read',
            },
            {
                label: 'SEO guide for beginners',
                link: `${Urls.MANGOOLS_SEO_ACADEMY_URL}?ref=header-app-kw`,
                description: '129 min read',
            },
        ],
    },
    {
        label: 'Other',
        items: [
            {
                label: 'Mangools Blog',
                link: `${Urls.MANGOOLS_BLOG_URL}?ref=header-app-kw`,
            },
            {
                label: 'Affiliate program',
                link: `${Urls.MANGOOLS_AFFILIATE_URL}?ref=header-app-kw`,
            },
            {
                label: 'FAQ',
                link: `${Urls.MANGOOLS_FAQ_URL}?ref=header-app-kw`,
            },
        ],
    },
];